import {
  IconPlus,
  IndigoIndigo60,
  Primary13SemiBold,
  SimpleTableInput,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import { PriceEditorTier } from 'common/drawers/PricingEditor/domain'
import { ValidationError } from '@sequencehq/utils'
import { useFixedTierTableInput } from './useFixedTierTableInput'
import { Currency } from '@sequencehq/api'

type FixedTierTableInputProps = {
  onChange: (value: PriceEditorTier[]) => void
  value: PriceEditorTier[]
  isDisabled: boolean
  currency: Currency
  validationErrors: ValidationError[]
}

export const FixedTierTableInput: FC<FixedTierTableInputProps> = props => {
  const { fieldConfig, addNewTier } = useFixedTierTableInput(props)

  return (
    <>
      <SimpleTableInput {...fieldConfig} data-testid="priceEditor.tiers" />
      <Flex justifyContent="center" marginTop="8px">
        <Flex
          {...Primary13SemiBold}
          width="fit-content"
          color={IndigoIndigo60}
          onClick={() => addNewTier()}
          _hover={{ opacity: 0.7 }}
          cursor="pointer"
          padding="4px 0"
          alignItems="center"
          data-testid="priceEditor.tiers.addTier"
          gap="4px"
        >
          <IconPlus /> Add another tier
        </Flex>
      </Flex>
    </>
  )
}
